module.exports = __webpack_public_path__ + "img/arm-header-icons-01.86ae94a4.svg";